import { styled } from "@mui/material";

export const StyledForm = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
  flex: '1 1 auto',
  padding: '25px 12px 20px',
});
